import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './Route_system/App';
import reportWebVitals from './reportWebVitals';

// 🧩 Global custom alert + confirm override
window.customDialogActive = false;

const showDialog = (message, options = {}) => {
  if (window.customDialogActive) return Promise.resolve(false);
  window.customDialogActive = true;

  return new Promise((resolve) => {
    // Overlay (background dim)
    const overlay = document.createElement('div');
    Object.assign(overlay.style, {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0, 0, 0, 0.4)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 999999,
      opacity: 0,
      transition: 'opacity 0.25s ease',
    });

    // Modal container
    const modal = document.createElement('div');
    Object.assign(modal.style, {
      background: '#ffffff',
      color: '#000000',
      padding: '20px 25px',
      borderRadius: '24px',
      boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
      minWidth: '280px',
      maxWidth: '80%',
      textAlign: 'center',
      fontSize: '14px',
      fontWeight: '500',
      display: 'flex',
      flexDirection: 'column',
      gap: '24px',
      transform: 'translateY(-10px)',
      transition: 'transform 0.25s ease',
    });

    // Message text
    const text = document.createElement('div');
    text.textContent = message;

    // Buttons container
    const buttons = document.createElement('div');
    Object.assign(buttons.style, {
      display: 'flex',
      justifyContent: 'center',
      gap: '12px',
    });

    // OK / Yes button
    const okBtn = document.createElement('button');
    okBtn.textContent = options.type === 'confirm' ? 'Yes' : 'OK';
    Object.assign(okBtn.style, {
      background: '#000000ff',
      color: 'white',
      border: 'none',
      padding: '8px 18px',
      borderRadius: '20px',
      cursor: 'pointer',
      fontWeight: '500',
    });
    okBtn.onclick = () => closeDialog(true);

    buttons.appendChild(okBtn);

    // Cancel button for confirm dialogs
    if (options.type === 'confirm') {
      const cancelBtn = document.createElement('button');
      cancelBtn.textContent = 'Cancel';
      Object.assign(cancelBtn.style, {
        background: '#f1f1f1',
        color: '#333',
        border: 'none',
        padding: '8px 18px',
        borderRadius: '20px',
        cursor: 'pointer',
        fontWeight: '500',
      });
      cancelBtn.onclick = () => closeDialog(false);
      buttons.appendChild(cancelBtn);
    }

    modal.appendChild(text);
    modal.appendChild(buttons);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    // Fade in animation
    requestAnimationFrame(() => {
      overlay.style.opacity = 1;
      modal.style.transform = 'translateY(0)';
    });

    // Helper to close and clean up
    function closeDialog(value) {
      overlay.style.opacity = 0;
      modal.style.transform = 'translateY(-10px)';
      setTimeout(() => {
        document.body.removeChild(overlay);
        window.customDialogActive = false;
        resolve(value);
      }, 250);
    }
  });
};

// 🔁 Override browser alert + confirm globally
window.alert = (msg) => showDialog(msg);
window.confirm = (msg) => showDialog(msg, { type: 'confirm' });

// 🔰 React app render
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ✅ Keep your performance metrics
reportWebVitals();